import { followUserById } from 'Services/api/user/following/followUserById';
import { unfollowUserById } from 'Services/api/user/following/unfollowUserById';
import { getFollowingAuthors } from 'Services/api/user/following/getFollowingAuthors';
import { getEmailNotifications } from 'Services/api/user/notifications/getEmailNotifications';
import { createEmailNotifications } from 'Services/api/user/notifications/createEmailNotifications';
import { deleteEmailNotifications } from 'Services/api/user/notifications/deleteEmailNotifications';
import { TAGS } from 'Services/api/newsletterProducts/constants';

export enum USER_TYPE {
  User = 'User',
  WallStreetBreakfast = 'WallStreetBreakfast',
}

export const FUNCTIONS_MAP_BY_USER_TYPE = {
  [USER_TYPE.User]: {
    subscribe: followUserById,
    unsubscribe: unfollowUserById,
    getFollowings: getFollowingAuthors,
  },
  [USER_TYPE.WallStreetBreakfast]: {
    getFollowings: () => {
      return getEmailNotifications([TAGS.wallStreetBreakfast]);
    },
    subscribe: () => {
      return createEmailNotifications({
        newsletters: [TAGS.wallStreetBreakfast],
      });
    },
    unsubscribe: () => {
      return deleteEmailNotifications({
        newsletters: [TAGS.wallStreetBreakfast],
      });
    },
  },
};
